// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#typography .small-text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  #typography .small-text {
    font-size: 9rem;
  }
}
#typography .medium-text {
  color: #fff;
  font-size: 15rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 660px) {
  #typography .medium-text {
    font-size: 12rem;
  }
}
#typography .sub-title {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #typography .sub-title {
    font-size: 17rem;
  }
}
#anim .reveal[visible] {
  opacity: 1;
  transform: translateX(0) translateY(0) rotate(0deg);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 71rem 99rem 0;
  width: 100%;
  z-index: 1;
  position: sticky;
}
.header .header__logo {
  width: 95rem;
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
  transition-delay: 0.5s;
  transform: translateX(-20rem);
  opacity: 0;
}
.header .header-nav {
  display: flex;
  width: 50%;
  justify-content: space-between;
  align-items: center;
}
.header .header-nav .header-link {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  .header .header-nav .header-link {
    font-size: 9rem;
  }
}
.header .header-nav .header-link:nth-child(1) {
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
  transition-delay: 0.1s;
  transform: translateX(-20rem);
  opacity: 0;
}
.header .header-nav .header-link:nth-child(2) {
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
  transition-delay: 0.2s;
  transform: translateX(-20rem);
  opacity: 0;
}
.header .header-nav .header-link:nth-child(3) {
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
  transition-delay: 0.3s;
  transform: translateX(-20rem);
  opacity: 0;
}
.header .header-nav .header-link:nth-child(4) {
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
  transition-delay: 0.4s;
  transform: translateX(-20rem);
  opacity: 0;
}
.header .header-nav .header-link:nth-child(5) {
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
  transition-delay: 0.5s;
  transform: translateX(-20rem);
  opacity: 0;
}
.header .header-nav .header-link:hover {
  color: var(--primary-color);
}
@media (max-width: 660px) {
  .header .header-nav {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 10;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    margin-left: 0;
    padding-top: 134rem;
    padding-bottom: 100rem;
    background: #000;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.5s, visibility 0.5s;
  }
}
@media (max-width: 660px) {
  .header {
    padding: 23rem 20rem 0;
  }
}
main[loaded] .header__logo {
  opacity: 1;
  transform: translateY(0) translateX(0);
}
main[loaded] .header__burger {
  opacity: 1;
}
main.loaded-done .header-link {
  opacity: 1 !important;
  transform: translateY(0) translateX(0) !important;
}
.header__burger {
  z-index: 12;
  display: none;
  width: 25rem;
  height: 20rem;
  opacity: 0;
}
.header__burger span {
  display: block;
  position: relative;
  width: 25rem;
  height: 2rem;
  margin: auto;
  background-color: #fff;
  transition: transform 0.4s;
  transition: 0.6s 0.7s opacity, 0.4s transform;
}
.header__burger span::after {
  content: '';
  position: absolute;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: #fff;
  top: -7rem;
}
.header__burger span::before {
  content: '';
  position: absolute;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: #fff;
  bottom: -7rem;
}
@media (max-width: 660px) {
  .header__burger {
    display: flex;
  }
}
body.js-burger-menu-is-open .header__burger span {
  transform: rotate(45deg);
}
body.js-burger-menu-is-open .header__burger span::after {
  visibility: hidden;
}
body.js-burger-menu-is-open .header__burger span::before {
  transform: rotate(90deg) translateX(-7rem);
}
@media (max-width: 660px) {
  body.js-burger-menu-is-open .header-nav {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/mixins.style.less","webpack://./src/widgets/Header/ui/Header.style.less"],"names":[],"mappings":"AAAA;EAEQ,WAAA;ECAN,WAAW;EDEL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACAR;ADEQ;EAAA;IACI,eAAA;ECCV;AACF;ADbA;EAgBQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACAR;ADCQ;EAAA;IACI,gBAAA;ECEV;AACF;ADzBA;EA2BQ,WAAA;ECCN,gBAAgB;EDCV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACCR;ADAQ;EAAA;IACI,gBAAA;ECGV;AACF;ADUQ;EACI,UAAA;EACA,mDAAA;ACRZ;AA7BA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AA+BJ;AAtCA;EAUQ,YAAA;EDkBA,gEAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;ACcR;AA7CA;EAgBQ,aAAA;EACA,UAAA;EACA,8BAAA;EACA,mBAAA;AAgCR;AAnDA;EDXQ,WAAA;ECiEN,WAAW;ED/DL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACiER;AD/DQ;EAAA;IACI,eAAA;ECkEV;AACF;AA1CgB;EDKR,gEAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;ACwCR;AAhDgB;EDKR,gEAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;AC8CR;AAtDgB;EDKR,gEAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;ACoDR;AA5DgB;EDKR,gEAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;AC0DR;AAlEgB;EDKR,gEAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;ACgER;AApEY;EACI,2BAAA;AAsEhB;AAlEQ;EAAA;IACI,eAAA;IACA,MAAA;IACA,QAAA;IACA,OAAA;IACA,WAAA;IACA,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,cAAA;IACA,mBAAA;IACA,sBAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;IACA,oBAAA;IACA,yCAAA;EAqEV;AACF;AAlEI;EAAA;IACI,sBAAA;EAqEN;AACF;AAlEA;EAEQ,UAAA;EACA,sCAAA;AAmER;AAtEA;EAOQ,UAAA;AAkER;AA9DA;EAEQ,qBAAA;EACA,iDAAA;AA+DR;AA1DA;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AA4DJ;AAjEA;EAQQ,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,6CAAA;AA4DR;AA3DQ;EAtGJ,WAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AAoKJ;AAjEQ;EA1GJ,WAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AA8KJ;AAtEI;EAAA;IACI,aAAA;EAyEN;AACF;AAtEA;EAIY,wBAAA;AAqEZ;AApEY;EACI,kBAAA;AAsEhB;AApEY;EACI,0CAAA;AAsEhB;AAjEI;EAAA;IAEQ,UAAA;IACA,mBAAA;IACA,oBAAA;EAmEV;AACF","sourcesContent":["#typography {\n    .small-text {\n        color: #fff;\n        /* Text 1 */\n        font-size: 12rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: 0.2rem;\n\n        @media (max-width: 660px) {\n            font-size: 9rem;\n        }\n    }\n\n    .medium-text {\n        color: #fff;\n        font-size: 15rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        @media (max-width: 660px) {\n            font-size: 12rem;\n        }\n    }\n\n    .sub-title {\n        color: #fff;\n        /* H1 Headline */\n        font-size: 20rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 32px;\n        @media (max-width: 660px) {\n            font-size: 17rem;\n        }\n    }\n}\n\n#anim {\n    .defaultOpacityTransforms(@delay: 0s, @transform: translateY(0rem)) {\n        transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;\n        transition-delay: @delay;\n        transform: @transform;\n        opacity: 0;\n    }\n\n    .reveal {\n        &[visible] {\n            opacity: 1;\n            transform: translateX(0) translateY(0) rotate(0deg);\n        }\n    }\n}","@import 'mixins.style.less';\n\n.burger(@direction) {\n    content: '';\n    position: absolute;\n    left: 0;\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    @{direction}: -7rem;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 71rem 99rem 0;\n    width: 100%;\n    z-index: 1;\n    position: sticky;\n\n    .header__logo {\n        width: 95rem;\n        opacity: 0;\n        #anim.defaultOpacityTransforms(0.5s, translateX(-20rem))\n    }\n\n    .header-nav {\n        display: flex;\n        width: 50%;\n        justify-content: space-between;\n        align-items: center;\n        .header-link {\n            #typography.small-text();\n            each(range(5), {\n                &:nth-child(@{value}) {\n                    #anim.defaultOpacityTransforms(0.1s*@value, translateX(-20rem))\n                }\n            })\n            &:hover {\n                color: var(--primary-color);\n            }\n        }\n\n        @media (max-width: 660px) {\n            position: fixed;\n            top: 0;\n            right: 0;\n            left: 0;\n            z-index: 10;\n            flex-direction: column;\n            width: 100%;\n            min-height: 100%;\n            margin-left: 0;\n            padding-top: 134rem;\n            padding-bottom: 100rem;\n            background: #000;\n            opacity: 0;\n            visibility: hidden;\n            pointer-events: none;\n            transition: opacity .5s, visibility .5s;\n        }\n    }\n\n    @media (max-width: 660px) {\n        padding: 23rem 20rem 0;\n    }\n}\n\nmain[loaded] {\n    .header__logo {\n        opacity: 1;\n        transform: translateY(0) translateX(0);\n    }\n\n    .header__burger {\n        opacity: 1;\n    }    \n}\n\nmain.loaded-done {\n    .header-link {\n        opacity: 1 !important;\n        transform: translateY(0) translateX(0) !important;\n    }\n}\n\n\n.header__burger {\n    z-index: 12;\n    display: none;\n    width: 25rem;\n    height: 20rem;\n    opacity: 0;\n\n    span {\n        display: block;\n        position: relative;\n        width: 25rem;\n        height: 2rem;\n        margin: auto;\n        background-color: #fff;\n        transition: transform .4s;\n        transition: .6s .7s opacity, .4s transform;\n        &::after {\n            .burger(top)\n        }\n\n        &::before {\n            .burger(bottom)\n        }\n    }\n\n    @media (max-width: 660px) {\n        display: flex;\n    }\n}\n\nbody.js-burger-menu-is-open {\n    .header__burger {\n        // transform: rotate(-90deg);\n        span {\n            transform: rotate(45deg);\n            &::after {\n                visibility: hidden;\n            }\n            &::before {\n                transform: rotate(90deg) translateX(-7rem);\n            }\n        }\n    }\n\n    @media (max-width: 660px) {\n        .header-nav {\n            opacity: 1;\n            visibility: visible;\n            pointer-events: auto;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
